import { render } from "./AudioAnnotationForm.vue?vue&type=template&id=48bbb10d&scoped=true"
import script from "./AudioAnnotationForm.vue?vue&type=script&lang=js"
export * from "./AudioAnnotationForm.vue?vue&type=script&lang=js"

import "./AudioAnnotationForm.vue?vue&type=style&index=0&id=48bbb10d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bbb10d"]])

export default __exports__